// export const PRODUCTION_IMAGE_URL = "http://" + location.hostname + ":5128/";
// export const PRODUCTION_CURRENT_URL = "http://" + location.hostname + ":3000/";

// // export const VIDEO_CALL_URL = "http://52.34.207.5:5127";
// export const VIDEO_CALL_URL = "http://172.10.189.198:5128"; //local

// export const PRODUCTION_IMAGE_URL = "http://" + location.hostname + ":5128/";
// export const PRODUCTION_CURRENT_URL = "http://" + location.hostname + ":3000/";

// // export const VIDEO_CALL_URL = "http://52.34.207.5:5127";
// export const VIDEO_CALL_URL = "http://172.10.28.60:5128"; //local

// // // local

export const PRODUCTION_IMAGE_URL =
	process.env.REACT_APP_NODE_ENV !== "development"
		? "https://test.medfixhealth.com/"
		: "https://test.medfixhealth.com/";
// "http://" + location.hostname + ":4576/":
"http://" + location.hostname + ":4576/";
export const PRODUCTION_CURRENT_URL =
	process.env.REACT_APP_NODE_ENV !== "development"
		? "https://test.medfixhealth.com/"
		: // "http://" + location.hostname + ":3000/" :
		  "http://" + location.hostname + ":3000/";
// export const VIDEO_CALL_URL = "http://52.34.207.5:5127";
export const VIDEO_CALL_URL =
	process.env.REACT_APP_NODE_ENV !== "development"
		? "https://test.medfixhealth.com/"
		: "http://localhost:4576/"; //local

// staging
// export const PRODUCTION_IMAGE_URL = "http://" + location.hostname + ":5128/";
// export const PRODUCTION_CURRENT_URL = "http://" + location.hostname + ":5127/";
// export const VIDEO_CALL_URL = "http://52.34.207.5:5127";

// clientlive Production
// export const PRODUCTION_IMAGE_URL = "https://www.medfixhealth.com/";
// export const PRODUCTION_CURRENT_URL = "https://www.medfixhealth.com/";
// export const VIDEO_CALL_URL = "https://www.medfixhealth.com";

// clientliveTest
// export const PRODUCTION_IMAGE_URL = "http://localhost:5127/";
// export const PRODUCTION_CURRENT_URL = "http://localhost:5127/";
// export const VIDEO_CALL_URL = http://localhost:5127";"
// clientTestlive
// export const PRODUCTION_IMAGE_URL = "https://test.medfixhealth.com/";
// export const PRODUCTION_CURRENT_URL = "https://test.medfixhealth.com/";
// export const VIDEO_CALL_URL = "https://test.medfixhealth.com";

export const DISTANCE = [
	{ id: 0.5, value: "0.5 miles" },
	{ id: 1, value: "1 miles" },
	{ id: 5, value: "5 miles" },
	{ id: 10, value: "10 miles" },
	{ id: 20, value: "20 miles" },
	{ id: 50, value: "50 miles" },
	{ id: 100, value: "100 miles" },
	{ id: 101, value: "National" },
];
export const GENDER = [
	{ id: "Male", value: "Male" },
	{ id: "Female", value: "Female" },
];
export const LANGUAGE = [
	{ id: "English", value: "English" },
	{ id: "Bengali", value: "Bengali" },
	{ id: "Hindi", value: "Hindi" },
	{ id: "French", value: "French" },
	{ id: "German", value: "German" },
];
export const SPECIALIST_PROFILE_LANGUAGE = [
	{ id: "English", name: "English" },
	{ id: "Bengali", name: "Bengali" },
	{ id: "Hindi", name: "Hindi" },
	{ id: "French", name: "French" },
	{ id: "German", name: "German" },
];
export const fruits = ["apple", "watermelon"];

export const PHONENOCOUNTRYCODE = [
	"+1",
	"+7",
	"+20",
	"+27",
	"+30",
	"+31",
	"+32",
	"+33",
	"+34",
	"+36",
	"+39",
	"+40",
	"+41",
	"+43",
	"+44",
	"+45",
	"+46",
	"+47",
	"+48",
	"+49",
	"+51",
	"+52",
	"+53",
	"+54",
	"+55",
	"+56",
	"+57",
	"+58",
	"+60",
	"+61",
	"+62",
	"+63",
	"+64",
	"+65",
	"+66",
	"+81",
	"+82",
	"+84",
	"+86",
	"+90",
	"+91",
	"+92",
	"+93",
	"+94",
	"+95",
	"+98",
	"+211",
	"+212",
	"+213",
	"+216",
	"+218",
	"+220",
	"+221",
	"+222",
	"+223",
	"+224",
	"+225",
	"+226",
	"+227",
	"+228",
	"+229",
	"+230",
	"+231",
	"+232",
	"+233",
	"+234",
	"+235",
	"+236",
	"+237",
	"+238",
	"+239",
	"+240",
	"+241",
	"+242",
	"+243",
	"+244",
	"+245",
	"+246",
	"+247",
	"+248",
	"+249",
	"+250",
	"+251",
	"+252",
	"+253",
	"+254",
	"+255",
	"+256",
	"+257",
	"+258",
	"+260",
	"+261",
	"+262",
	"+263",
	"+264",
	"+265",
	"+266",
	"+267",
	"+268",
	"+269",
	"+290",
	"+291",
	"+297",
	"+298",
	"+299",
	"+350",
	"+351",
	"+352",
	"+353",
	"+354",
	"+355",
	"+356",
	"+357",
	"+358",
	"+359",
	"+370",
	"+371",
	"+372",
	"+373",
	"+374",
	"+375",
	"+376",
	"+377",
	"+378",
	"+380",
	"+381",
	"+382",
	"+383",
	"+385",
	"+386",
	"+387",
	"+388",
	"+389",
	"+420",
	"+421",
	"+423",
	"+473",
	"+500",
	"+501",
	"+502",
	"+503",
	"+504",
	"+505",
	"+506",
	"+507",
	"+508",
	"+509",
	"+590",
	"+591",
	"+592",
	"+593",
	"+594",
	"+595",
	"+596",
	"+597",
	"+598",
	"+599",
	"+670",
	"+672",
	"+673",
	"+674",
	"+675",
	"+676",
	"+677",
	"+678",
	"+679",
	"+680",
	"+681",
	"+682",
	"+683",
	"+685",
	"+686",
	"+687",
	"+688",
	"+689",
	"+690",
	"+691",
	"+692",
	"+850",
	"+852",
	"+853",
	"+855",
	"+856",
	"+872",
	"+880",
	"+886",
	"+960",
	"+961",
	"+962",
	"+963",
	"+964",
	"+965",
	"+966",
	"+967",
	"+968",
	"+970",
	"+971",
	"+972",
	"+973",
	"+974",
	"+975",
	"+976",
	"+977",
	"+992",
	"+993",
	"+994",
	"+995",
	"+996",
	"+998",
	"+1 242",
	"+1 246",
	"+1 264",
	"+1 268",
	"+1 284",
	"+1 340",
	"+1 345",
	"+1 441",
	"+1 649",
	"+1 664",
	"+1 670",
	"+1 671",
	"+1 684",
	"+1 721",
	"+1 758",
	"+1 767",
	"+1 784",
	"+1 868",
	"+1 869",
	"+1 876",
];

export const DEFAULT_USER_IMAGE = "noUserImage.jpg";

export const COMMON_FOLDER = "common/";

export const UPLOAD_FOLDER = "uploads/";

export const CURRENCY = [
	"AED",
	"AUD",
	"BHD",
	"CAD",
	"CHF",
	"DJF",
	"ETB",
	"EUR",
	"GBP",
	"INR",
	"NGN",
	"PKR",
	"RUB",
	"SAR",
	"SDG",
	"SGD",
	"TZS",
	"USD",
];

export const MORNING_START = {
	START: "00:00",
	END: "11:30",
	// END: "11:00"
};
export const MORNING_END = {
	START: "00:00",
	END: "11:30",
	// END: "12:00"
};
export const EVENING_START = {
	START: "12:00",
	END: "23:30",
};
export const EVENING_END = {
	START: "12:00",
	END: "23:30",
};

export const DEFAULT_RATING_STARS = 0;
